import React, { useState } from 'react';

const ChannelPartnerForm = () => {
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        phone: '',
        dob: '',
        address: '',
        companyName: '',
        designation: '',
        experience: '',
        background: '',
        licenseNumber: '',
        areasOfOperation: '',
        propertyType: '',
        commissionStructure: '',
        marketReach: '',
        partnershipGoals: '',
        cv: null,
        references: '',
        linkedinProfile: ''
    });

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setFormData({
            ...formData,
            [name]: files ? files[0] : value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form data submitted:', formData);
        // You can make an API call here to submit form data to the backend
    };

    return (
        // <div className="form-container">
        //     <h2>Channel Partner Application</h2>
        //     <p>Join Us as a Channel Partner and Help Drive Success in the Real Estate Market!</p>
        //     <form onSubmit={handleSubmit}>
        //         {/* Personal Information */}
        //         <input
        //             type="text"
        //             name="fullName" placeholder='Full name'
        //             value={formData.fullName}
        //             onChange={handleChange}
        //             required
        //         />


        //         <input
        //             type="email"
        //             name="email" placeholder='Email'
        //             value={formData.email}
        //             onChange={handleChange}
        //             required
        //         />


        //         <input
        //             type="text"
        //             name="phone" placeholder='Phone number'
        //             value={formData.phone}
        //             onChange={handleChange}
        //             required
        //         />

        //         <label>Date of Birth:</label>
        //         <input
        //             type="date"
        //             name="dob"
        //             value={formData.dob}
        //             onChange={handleChange}
        //         />


        //         <textarea
        //             name="address" placeholder='Address'
        //             value={formData.address}
        //             onChange={handleChange}
        //             required
        //         ></textarea>

        //         {/* Professional Information */}

        //         <input
        //             type="text"
        //             name="companyName" placeholder='Company name (if applicable)'
        //             value={formData.companyName}
        //             onChange={handleChange}
        //         />


        //         <input
        //             type="text"
        //             name="designation" placeholder='Designation'
        //             value={formData.designation}
        //             onChange={handleChange}
        //         />

        //         <label>Years of Experience:</label>
        //         <input
        //             type="number"
        //             name="experience"
        //             value={formData.experience}
        //             onChange={handleChange}
        //         />


        //         <textarea
        //             name="background" placeholder='Professional background'
        //             value={formData.background}
        //             onChange={handleChange}
        //         ></textarea>


        //         <input
        //             type="text"
        //             name="licenseNumber" placeholder='Real estate Licence number (if applicable)'
        //             value={formData.licenseNumber}
        //             onChange={handleChange}
        //         />

        //         {/* Business Information */}

        //         <input
        //             type="text"
        //             name="areasOfOperation" placeholder='Areas of Operation'
        //             value={formData.areasOfOperation}
        //             onChange={handleChange}
        //         />

        //         <label>Preferred Type of Properties:</label>
        //         <select
        //             name="propertyType"
        //             value={formData.propertyType}
        //             onChange={handleChange}
        //             required
        //         >
        //             <option value="">--Select--</option>
        //             <option value="Residential">Residential</option>
        //             <option value="Commercial">Commercial</option>
        //             <option value="Plots">Plots</option>
        //         </select>


        //         <textarea
        //             name="commissionStructure" placeholder='Prefered commission structure'
        //             value={formData.commissionStructure}
        //             onChange={handleChange}
        //         ></textarea>


        //         <textarea
        //             name="marketReach"
        //             value={formData.marketReach} placeholder='Current Market Reach/Clientele'
        //             onChange={handleChange}
        //         ></textarea>


        //         <textarea
        //             name="partnershipGoals"
        //             value={formData.partnershipGoals} placeholder='Partnership Goal'
        //             onChange={handleChange}
        //         ></textarea>

        //         {/* Additional Information */}
        //         <label>Upload CV/Portfolio:</label>
        //         <input
        //             type="file"
        //             name="cv"
        //             onChange={handleChange}
        //         />


        //         <textarea
        //             name="references"
        //             value={formData.references} placeholder='References'
        //             onChange={handleChange}
        //         ></textarea>


        //         <input
        //             type="url"
        //             name="linkedinProfile"
        //             value={formData.linkedinProfile} placeholder='LinkedIn Profile/Website (link)'
        //             onChange={handleChange}
        //         />

        //         {/* Agreement */}
        //         <div className='agreement'>

        //             <div>
        //                 <label>
        //                     I agree to the <a href="#">Terms and Conditions</a>
        //                 </label>
        //             </div>


        //             <div> <input type="checkbox" required /></div>
        //         </div>



        //         <button type="submit">Register</button>
        //     </form>
        // </div>


        <>
            <iframe
                src="https://login.masteraix.io/widget/form/6a2e5d96c0438"
                style={{
                    width: '100%',
                    height: '600px',
                    border: 'none',
                    borderRadius: '3px'
                }}
                id="inline-6a2e5d96c0438"
                data-form-name="Cp_meet_24June_2026"
                data-layout-iframe-id="inline-6a2e5d96c0438"
                data-form-id="6a2e5d96c0438"
                data-height="600"
                title="Cp_meet_24June_2026"
            />

        </>

    );
};

export default ChannelPartnerForm;
